<div class="progress-bar-container" *ngIf="progressBarService.isLoading()" @progressAnimation>
  <div class="progress-bar-fill"></div>
</div>
